module.exports = __webpack_public_path__ + "static/media/close.d69abbe6.svg";